import React from 'react';
import { LoadingSpinner } from '../../../atoms/LoadingSpinner';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type BlockInteractionsLoadingSpinnerType = {
  uuid: string;
  contentWrapperProps?: ContentWrapperContext | null;
};
/**
 * When the block is moved by user interaction or added new block, the process is indicated here.
 */
export function BlockInteractionsLoadingSpinner({ uuid, contentWrapperProps }: BlockInteractionsLoadingSpinnerType) {
  if (contentWrapperProps?.action?.uuid === uuid) {
    return (
      <div className="block-interactions__spinner">
        <LoadingSpinner />
      </div>
    );
  }
  return null;
}
